import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import client from '../../api/client';
import { getAuthenticatedHomePath } from '../../config/roleAccess';
import { getSafeReturnPath } from './authReturnPath';

function LoginPage() {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await client.post('/api/auth/login', { identifier, password });
      login(response.data.token, response.data.user);
      navigate(response.data.user?.must_change_password
        ? '/passwort-aendern'
        : getSafeReturnPath(location.state) || getAuthenticatedHomePath(response.data.user), { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ width: '100%', maxWidth: 440 }}>
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack spacing={3}>
          <Box sx={{ textAlign: 'center' }}>
            <img
              src="/logo.jpeg"
              alt="Höhenrettung Logo"
              style={{ height: 80, objectFit: 'contain', marginBottom: 16, borderRadius: 8 }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Höhenrettung Stundennachweis
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Anmeldung
            </Typography>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}
          {location.state?.passwordSet && (
            <Alert severity="success">Passwort wurde festgelegt. Sie können sich jetzt anmelden.</Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack spacing={2.5}>
              <TextField
                fullWidth
                label="E-Mail oder Name (Nachname, Vorname)"
                placeholder="E-Mail oder Nachname, Vorname"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                disabled={loading}
                autoFocus
              />
              <TextField
                fullWidth
                label="Passwort"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={loading}
              >
                {loading ? 'Wird angemeldet...' : 'Anmelden'}
              </Button>
            </Stack>
          </form>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default LoginPage;
